module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text",
      "onclick": "location.reload()"
    }
  }, [_vm._v("刷新页面  "), _c('i', {
    staticClass: "el-icon-refresh"
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商家id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "merchant_id", $$v)
      },
      expression: "params.merchant_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.distributor_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_id", $$v)
      },
      expression: "params.distributor_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.params.order_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "order_id", $$v)
      },
      expression: "params.order_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "订单状态"
    },
    model: {
      value: (_vm.params.order_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "order_status", $$v)
      },
      expression: "params.order_status"
    }
  }, _vm._l((_vm.orderArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "结算状态"
    },
    model: {
      value: (_vm.params.settle_accounts_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "settle_accounts_status", $$v)
      },
      expression: "params.settle_accounts_status"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "placeholder": "审核状态"
    },
    model: {
      value: (_vm.params.verify),
      callback: function($$v) {
        _vm.$set(_vm.params, "verify", $$v)
      },
      expression: "params.verify"
    }
  }, _vm._l((_vm.verifyArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "placeholder": "账单状态"
    },
    model: {
      value: (_vm.params.account_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "account_status", $$v)
      },
      expression: "params.account_status"
    }
  }, _vm._l((_vm.statusArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "归属账期"
    },
    model: {
      value: (_vm.params.belong_billing_date),
      callback: function($$v) {
        _vm.$set(_vm.params, "belong_billing_date", $$v)
      },
      expression: "params.belong_billing_date"
    }
  }, _vm._l((_vm.paymentList), function(item) {
    return _c('el-option', {
      key: item.belong_billing_date,
      attrs: {
        "label": item.belong_billing_date,
        "value": item.belong_billing_date
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "mini",
      "type": "daterange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.params.times),
      callback: function($$v) {
        _vm.$set(_vm.params, "times", $$v)
      },
      expression: "params.times"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.upAccountFile('update')
      }
    }
  }, [_vm._v("更新通联对账数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.getExport(0)
      }
    }
  }, [_vm._v("下载对账汇总")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.getExport(1)
      }
    }
  }, [_vm._v("下载对账汇总(按交易)")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.fileExport()
      }
    }
  }, [_vm._v("下载通联对账")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "可选择时间段",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', [_c('el-dropdown', {
    on: {
      "command": _vm.upAccountFile
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("\n                下载通联对账文件"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "1"
    }
  }, [_vm._v("对账明细TXT")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "2"
    }
  }, [_vm._v("对账汇总TXT")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "3"
    }
  }, [_vm._v("对账单XLSX")])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "对账文件只能选择下载某一天的数据",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1)], 1), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "今日订单于第二天进行自动比对!",
      "type": "info",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), (_vm.checkNumber.order_total) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("选择数量: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.checkNumber.order_total))])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("\n                     通联比对统计:\n                     "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("比对成功:" + _vm._s(_vm.checkNumber.success))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("比对失败:" + _vm._s(_vm.checkNumber.fail))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("待比对:" + _vm._s(_vm.checkNumber.wait))])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("结算数量:\n                "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("已入账:" + _vm._s(_vm.checkNumber.accounts_success))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("未入账:" + _vm._s(_vm.checkNumber.accounts_fail))])])]), _vm._v(" "), _c('li', [_vm._v("\n                金额总计:\n                "), _c('span', [_vm._v("金额: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s((_vm.checkNumber.total_fee / 100).toFixed(2)))]), _vm._v(" 元 ")]), _vm._v(" "), _c('span', [_vm._v("手续费: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s((_vm.checkNumber.fee / 100).toFixed(2)))]), _vm._v(" 元 ")])])])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 130
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.show(scope.row)
            }
          }
        }, [_vm._v("明细详情")]), _vm._v(" "), (scope.row.third_status == 'FAIL') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toCheckAccount(scope.row)
            }
          }
        }, [_vm._v("重新校对")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通联对账比对"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.third_status == 'WAIT' ? 'info' : scope.row.third_status == 'SUCCESS' ? 'success' : 'danger'
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.third_status) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_total_fee",
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('ul', [_c('li', [_c('el-tag', {
          attrs: {
            "type": "pramary",
            "size": "mini"
          }
        }, [_vm._v("￥" + _vm._s((scope.row.order_total_fee / 100).toFixed(2)))])], 1), _vm._v(" "), _c('li', [_c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("￥" + _vm._s((parseInt(scope.row.third_amount) / 100).toFixed(2)))])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "平台应收款"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('ul', [_c('li', [_c('el-tag', {
          attrs: {
            "type": "pramary",
            "size": "mini"
          }
        }, [_vm._v("￥" + _vm._s(((parseInt(scope.row.platform_service_fee02) + parseInt(scope.row.platform_service_fee01)) / 100).toFixed(2)))])], 1), _vm._v(" "), _c('li', [_c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("￥" + _vm._s((parseInt(scope.row.third_fee) / 100).toFixed(2)))])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "label": "订单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.order_id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchant_id",
      "label": "商家id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.merchant_id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "belong_billing_date",
      "label": "归属账期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.belong_billing_date))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_create_time",
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.order_create_time))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_id",
      "label": "店铺id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.distributor_id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "店铺名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('small', [_vm._v(_vm._s(scope.row.distributor_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品总价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n           ￥" + _vm._s((scope.row.items_total_fee / 100).toFixed(2)) + "\n         ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "配送费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            ￥" + _vm._s((scope.row.freight_fee / 100).toFixed(2)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchant_receivables",
      "label": "商家应收款"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            ￥" + _vm._s((scope.row.merchant_receivables / 100).toFixed(2)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settle_accounts_status",
      "label": "结算状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.settle_accounts_status == '未入账' ? 'info' : 'success'
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.settle_accounts_status) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini",
            "type": scope.row.order_status == 'CANCEL' ? 'parmary' : 'success'
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.order_status == 'CANCEL' ? '已退款' : '已收款') + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account_status_str == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": "danger"
          }
        }, [_c('s', [_vm._v("无效账单")])]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": "success"
          }
        }, [_vm._v("\n             有效账单\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [20, 50, 100, 200],
      "total": _vm.total_count,
      "page-size": _vm.params.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.account_title,
      "visible": _vm.dialogUpAccountVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogUpAccountVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.account_date),
      callback: function($$v) {
        _vm.account_date = $$v
      },
      expression: "account_date"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.accountSubmit()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title2,
      "visible": _vm.dialogVisible2,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toRemarksSubmit()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "width": "50%",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("订单号:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.order_id))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("门店名称:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.distributor_name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("商家id:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.merchant_id))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("门店id:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.distributor_id))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("交易时间:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.order_create_time))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("账单日期:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_vm._v(_vm._s(_vm.row.billing_date))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("归属账期:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.row.belong_billing_date))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("结算状态:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.row.settle_accounts_status == '未入账' ? 'info' : 'success',
      "size": "mini"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.row.settle_accounts_status) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("商品总价:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.items_total_fee / 100).toFixed(2)) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("商家承担配送费:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.merchant_freight_fee / 100).toFixed(2)) + " ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("订单状态:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini",
      "type": _vm.row.order_status == 'CANCEL' ? 'info' : 'success'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.row.order_status == 'CANCEL' ? '已退款' : '已收款') + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("配送费:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.freight_fee / 100).toFixed(2)) + " ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("配送方式:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini",
      "type": _vm.row.is_merchant_delivery == 0 ? 'info' : 'success'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.row.is_merchant_delivery == 0 ? '平台配送' : '商家自配送') + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("用户支付金额: ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.order_total_fee / 100).toFixed(2)))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "(商品总价 + 用户支付配送费 + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台会员折扣金额 - 平台优惠券抵扣金额)",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("商家应收款:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.merchant_receivables / 100).toFixed(2)))]), _vm._v(" "), (_vm.row.is_merchant_delivery == 0) ? _c('el-tooltip', {
    attrs: {
      "content": "(商品总价  + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台服务费 - 平台服务费2)",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })]) : _c('el-tooltip', {
    attrs: {
      "content": " ( 商品总价 + 用户支付配送费 + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台服务费 - 平台服务费2)",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("商家优惠券抵扣金额:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini "
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.merchant_coupon_discount / 100).toFixed(2)))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台优惠券抵扣金额:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini "
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_coupon_discount / 100).toFixed(2)))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("商家会员折扣金额:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.merchant_member_discount / 100).toFixed(2)))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台会员折扣金额:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_member_discount / 100).toFixed(2)))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("打包费:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.packing_fee / 100).toFixed(2)) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台应收款:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_service_fee01 / 100).toFixed(2)) + " ")]), _vm._v(" "), (_vm.row.is_merchant_delivery == 0) ? _c('el-tooltip', {
    attrs: {
      "content": " 平台服务费 + 用户支付配送费",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })]) : _c('el-tooltip', {
    attrs: {
      "content": " (商品总价 + 打包费 - 商家活动支出 ) * 费率",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台服务费:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_fee / 100).toFixed(2)) + " ")]), _vm._v(" "), (_vm.row.is_merchant_delivery == 0) ? _c('el-tooltip', {
    attrs: {
      "content": " (商品总价 + 打包费 - 商家活动支出  + 用户支付配送费) * 费率 ",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })]) : _c('el-tooltip', {
    attrs: {
      "content": " (商品总价 + 打包费 - 商家活动支出 ) * 费率",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台服务费2:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_service_fee02 / 100).toFixed(2)) + " ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台服务费保底:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("￥" + _vm._s((_vm.row.platform_service_base_fee / 100).toFixed(2)) + " ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("平台服务费费率:")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.row.platform_service_rate) + "% ")])], 1), _vm._v(" "), (_vm.row.remarks) ? _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 4
    }
  }, [_vm._v("备注:")]) : _vm._e(), _vm._v(" "), (_vm.row.remarks) ? _c('el-col', {
    attrs: {
      "size": "mini",
      "span": 7
    }
  }, [_c('span', [_c('small', [_vm._v(_vm._s(_vm.row.remarks))])])]) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fdb22292", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdb22292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/merchant/account/detail.vue
// module id = 3002
// module chunks = 0